"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var meterReadThanksLabelPropTypes = {
  metersRegisteredText: _propTypes.default.string.isRequired,
  fromToMetersRegisteredText: _propTypes.default.string.isRequired,
  revisitHint: _propTypes.default.string.isRequired,
  thankYouText: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  emailConfirmationText: _propTypes.default.string.isRequired,
  okoConfirmationText1: _propTypes.default.string.isRequired,
  okoConfirmationText2: _propTypes.default.string.isRequired,
  returnUrl: _propTypes.default.string.isRequired,
  backButton: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    version: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = exports.default = meterReadThanksLabelPropTypes;